import { useEffect } from 'react';
import { clickableTags } from 'pages/Pipefy/config';

export const useHideOnClickOutside = (setState: React.Dispatch<React.SetStateAction<boolean>>): void => {

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (clickableTags.includes(target.tagName)) {
        setState(false);
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [setState]);
};
